var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paid)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0FDF4",
    d: "M5.375 5.375a.875.875 0 0 0-.875.875v.438h7V6.25a.875.875 0 0 0-.875-.875h-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0FDF4",
    fillRule: "evenodd",
    d: "M11.5 7.563h-7V9.75c0 .483.392.875.875.875h5.25a.875.875 0 0 0 .875-.875V7.562Zm-6.125 1.75c0-.242.196-.438.438-.438h.437a.438.438 0 0 1 0 .875h-.438a.438.438 0 0 1-.437-.438Zm2.188-.438a.438.438 0 0 0 0 .875H8a.438.438 0 0 0 0-.875h-.438Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paid"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.f171b3cbea091278e90bea3707f90198.svg";
export { ForwardRef as ReactComponent };